/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPageButton } from './formPageButton';
import { FormPageType } from './formPageType';
import { FormPageRequiredErrorMessage } from './formPageRequiredErrorMessage';
import { FormPageProgressBar } from './formPageProgressBar';
import { FormPageFooter } from './formPageFooter';
import { FormPageHeader } from './formPageHeader';
import { FormPagePropertyItem } from './formPagePropertyItem';
import { FormPageDesign } from './formPageDesign';
import { FormPageInvalidInputErrorSetting } from './formPageInvalidInputErrorSetting';


/**
 * フォームページ JSONスキーマに準拠する
 */
export interface FormPage { 
    /**
     * フォームのページ ID
     */
    pageId: string;
    /**
     * ページのタイトル ※将来的に埋め込みコマンドで個人情報を埋め込むこともありうる
     */
    title?: string;
    /**
     * ページのメッセージ ※将来的に埋め込みコマンドで個人情報を埋め込むこともありうる
     */
    message: string;
    pageType: FormPageType;
    /**
     * JSONスキーマに準拠してobject固定
     */
    type: FormPage.TypeEnum;
    header: FormPageHeader;
    footer: FormPageFooter;
    progressBar?: FormPageProgressBar;
    design: FormPageDesign;
    invalidInputError: FormPageInvalidInputErrorSetting;
    /**
     * フォームの入力項目（properties）の中で、入力必須なものを示す
     */
    required?: Array<string>;
    /**
     * フォームの入力項目の並び順を、入力項目のID（UUID想定）の配列で示す
     */
    uiOrder?: Array<string>;
    /**
     * フォームのボタン
     */
    submissions?: Array<FormPageButton>;
    errorMessage?: FormPageRequiredErrorMessage;
    /**
     * フォームの入力項目。入力項目のID（UUID想定）がキー、入力項目の設定内容が値の動的Map形式
     */
    properties: { [key: string]: FormPagePropertyItem; };
}
export namespace FormPage {
    export type TypeEnum = 'object';
    export const TypeEnum = {
        Object: 'object' as TypeEnum
    };
}



